import React, { useState, useEffect } from 'react'
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import SPComponentsGrid from './spComponentsGrid';
import { VIEW, UPDATE, DELETE, NEW } from '../../assets/Constants/actionsTypes';
import API from "../../services/api";
import validator from 'validator';
import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';
import SPComponentsModal from './spComponentsModal';
import { useTranslation } from 'react-i18next';

// Css file
import './spComponents.css'

const SPComponent = () => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');
    /**State of the modal window. True = showing ... False = hidden */
    const [showModal, setShowModal] = useState(false);
    /** State of the dialog. True = showing ... False = hidden */
    const [showAlert, setShowAlert] = useState(false);
    // List of components. See useEffect
    const [componentsList, setComponentsList] = useState([]);
    // Single component
    const [componentData, setComponentData] = useState({});
    // Modal Window type = DELETE, NEW, VIEW or UPDATE
    const [viewType, setViewType] = useState('');

    // we use useEffect to call the function that fills the grid
    useEffect(() => {
        getComponentsList();
    }, [])

    // Function that updates the componentsList variable in the state. This list will be used to fill the grid 
    const getComponentsList = async () => {
        setComponentsList([]);
        try {
            const response = await API.get('/spcomponent/getAll');
            setComponentsList(response.data.data);
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    // Show or hide the modal window. See state variable
    const toggleWindow = () => {
        setShowModal(!showModal);
    }

    // Show or hide the alert dialog. See state variable
    const toggleAlert = () => {
        setShowAlert(!showAlert);
    }

    // Triggered when the user clicks an action in the grid. Opens the modal window according to the selection
    const onActionClick = (actionItem, dataItme) => {
        const action = actionItem.value;
        setViewType(action);
        setComponentData(dataItme);

        switch (action) {
            case NEW:
                toggleWindow();
                break;
            case VIEW:
                toggleWindow();
                break;
            case UPDATE:
                toggleWindow();
                break;
            case DELETE:
                toggleAlert();
                break;
            default:
                break;
        }
    }
    /**
   ** The upsert call is handled here
   */
    const onSave = async (data) => {
        try {
            // * validate required fiels
            if (validator.isEmpty(data.name)) {
                Notifications.notify(t('spComponent.name_required'), ERROR_NOTIFICATION);
                return;
            }

            // * we apply the trim to the fields
            data = {
                ...data,
                name: validator.trim(data.name),
                description: validator.trim(data.description)
            }

            // * call the api to do the upsert
            const res = await API.post('/spcomponent/upsert', data);

            // * if errors exist, it is displayed as a notification
            if (res.data.code !== 100) {
                Notifications.notify(t(`spComponent.${res.data.code}`), ERROR_NOTIFICATION);
                return;
            }

            // * we decide what kind of message of success we should give
            const msg = data.spComponentId === 0 ? t('spComponent.new_message') : t('spComponent.update_message');

            // * hide the modal and refresh the grid
            toggleWindow();
            Notifications.notify(msg, SUCCESS_NOTIFICATION);
            getComponentsList();

        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    /**
   ** The delete call is handled here
   */
    const onDelete = async () => {
        try {
            // * call the api to do the delete
            const res = await API.delete(`/spComponent?spComponentId=${componentData.spComponentId}`);

            // * if errors exist, it is displayed as a notification
            if (res.data.code !== 100) {
                Notifications.notify(t(`spComponent.${res.data.code}`), ERROR_NOTIFICATION);
                return;
            }

            // * hide the alert and refresh the grid
            toggleAlert();
            Notifications.notify(t('spComponent.delete_message'), SUCCESS_NOTIFICATION);
            getComponentsList();
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    return (
        <>
            <div className="sub_menu">
                <div className="sub_menu_btns my-1">
                    <button className="btn btn-primary ilo-btn" onClick={() => onActionClick({ value: NEW }, {})}>{t('spComponent.new_btn')}</button> | <span className="ilo-section-title p-1">{t('spComponent.modal_title')}</span>
                </div>
            </div>
            <div className="container-fluid mt-1">
                {/* modal window */}
                {showModal && <SPComponentsModal type={viewType} data={componentData} toggleWindow={toggleWindow} onSave={onSave} />}

                {/* alert window */}
                {showAlert &&
                    <Dialog
                        className="ilo-delete-confirm"
                        title={t('spComponent.delete_title')}
                        onClose={() => toggleAlert()}
                    >
                        <p style={{ margin: "25px", textAlign: "center" }}>{t('spComponent.delete_body')}</p>
                        <DialogActionsBar layout="end">
                            <button className="k-button" onClick={onDelete}>{t('alerts.yes_btn')}</button>
                            <button className="k-button" onClick={toggleAlert}>{t('alerts.no_btn')}</button>
                        </DialogActionsBar>
                    </Dialog>
                }

                <div className="row">
                    {/* grid */}
                    <div className="container_grid">
                        <SPComponentsGrid data={componentsList} onActionClick={onActionClick} />
                    </div>
                </div>
            </div>
        </>
    );
}
export default SPComponent